import { Role } from '@okletsplay/core';
import { Route } from 'app/enums';
import { NavigationMenuItem } from 'app/interfaces/sidebar';
import { AppCountersContext } from 'app/providers/AppCountersProvider';
import clockIcon from 'assets/images/clock_icon.svg';
import gamepadIcon from 'assets/images/gamepad_icon.svg';
import plusIcon from 'assets/images/plus_icon.svg';
import { useRoles } from 'modules/auth/hooks';
import { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

interface TournamentMenuItemsHook {
  tournamentMenuItems: NavigationMenuItem[];
}

export function useTournamentMenuItems(): TournamentMenuItemsHook {
  const navigate = useNavigate();
  const { activeTournamentsCount, pastTournamentsCount } = useContext(AppCountersContext);

  const { hasAnyRole } = useRoles();

  const tournamentMenuItems = useMemo((): NavigationMenuItem[] => {
    const menuItems: NavigationMenuItem[] = [
      {
        label: 'My Active Tournaments',
        badge: activeTournamentsCount,
        onClick: () => navigate(Route.MyActiveTournaments),
        route: Route.MyActiveTournaments,
        icon: gamepadIcon,
        roles: [Role.CommunityTournamentCreator, Role.TournamentCreator],
      },
      {
        label: 'My Past Tournaments',
        badge: pastTournamentsCount,
        onClick: () => navigate(Route.MyPastTournaments),
        route: Route.MyPastTournaments,
        icon: clockIcon,
        roles: [Role.CommunityTournamentCreator, Role.TournamentCreator],
      },
      {
        label: 'Create Tournament',
        onClick: () => navigate(Route.CreateTournament),
        route: Route.CreateTournament,
        icon: plusIcon,
        roles: [],
        isAllowedWithoutAuthorization: true,
      },
    ];

    return menuItems.filter((item) => hasAnyRole(item?.roles ?? []));
  }, [activeTournamentsCount, hasAnyRole, navigate, pastTournamentsCount]);

  return { tournamentMenuItems };
}
